import React from "react";
import LocalizedLink from "../containers/LocalizedLink";

import SupportQuestionAnswer from "./SupportQuestionAnswer";

const SupportAcoustic = props => (
  <React.Fragment>
  <section className="grid grid--3" style={{ marginTop: "55px" }}>
    <LocalizedLink className="grid__item" to="/support/business">
      <div className="grid__item-title">{props.t("support:titleBusinessQuestion")}</div>
    </LocalizedLink>
    <LocalizedLink className="grid__item" to="/support/technical">
      <div className="grid__item-title">{props.t("support:titleTechnicalQuestion")}</div>
    </LocalizedLink>
    <LocalizedLink className="grid__item" to="/support/acoustic">
      <div className="grid__item-title font-bold">{props.t("support:titleAcousticQuestion")}</div>
    </LocalizedLink>
  </section>

    <div className="grid grid--3 flex-wrap">
      <SupportQuestionAnswer
        question={props.t("question1")}
        boldWords={props.t("boldWords1")}
        answer={props.t("answer1")}
        classQuestion="question"
      />
      <SupportQuestionAnswer
      question={props.t("question2")}
      boldWords={props.t("boldWords2")}
      answer={props.t("answer2")}
        classQuestion="question"
      />
      <SupportQuestionAnswer
      question={props.t("question3")}
      boldWords={props.t("boldWords3")}
      answer={props.t("answer3")}
        classQuestion="question"
      />
      <div className="grid__item support__item" />
      <div className="grid__item support__item" />
      <div className="grid__item support__item" />
      <div className="grid__item support__item" />
      <div className="grid__item support__item" />
      <div className="grid__item support__item" />
    </div>
  </React.Fragment>
);

export default SupportAcoustic;



// WEBPACK FOOTER //
// ./src/components/SupportAcoustic.js